var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKor = function SvgKor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0039A6",
    d: "M5.996 11.95c0 3.274 2.7 5.95 6.005 5.95s6.004-2.676 6.004-5.95z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 3,
    fill: "#DC143C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC143C",
    d: "M18.005 11.95c0-3.275-2.7-5.95-6.004-5.95-3.306 0-6.005 2.675-6.005 5.95z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039A6",
    d: "M18 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m16.414 3 3.536 3.535-1.415 1.415L15 4.414zM18.414 1l3.536 3.535-1.415 1.415L17 2.414zM4 6.535 7.535 3 8.95 4.414 5.414 7.949zM2 4.535 5.535 1 6.95 2.414 3.414 5.949zM7.535 20.95 4 17.413 5.414 16l3.535 3.535zM5.535 22.95 2 19.413 3.414 18l3.535 3.535zM19.95 17.414l-3.536 3.536L15 19.535 18.535 16zM21.95 19.414l-3.536 3.536L17 21.535 20.535 18z"
  })));
};
export default SvgKor;